{
  "id": "azure",
  "name": "Microsoft",
  "priority": 20,
  "description": "Adds a Microsoft Azure authentication provider."
}
